import { message } from 'antd';
import { ManualAlert } from '@conviva/portal-graphql-schema';
import { get } from 'lodash';
import { useMutation } from '@apollo/react-hooks';
import { TOGGLE_ALERTS } from '@api/graphql/manualAlerts';

const useToggle = () => {
  const [toggleAlerts] = useMutation(TOGGLE_ALERTS, {
    onCompleted(data) {
      const alert: ManualAlert = get(data, 'toggleManualAlerts.0')
      const { state, name } = alert;
      message.success(`Alert ${name} ${state ? 'enabled' : 'disabled'}!`);
    }
  });
  return toggleAlerts;
}

export default useToggle;
